import {useTranslation} from 'react-i18next';
import KakaoAuth from './KakaoAuth';
import Alert from '../../common/component/Alert';
import {ButtonSet} from '../../common/type/alert';
import {LOGIN_KR_TITLE_KEY_MAP} from '../common';
import {IAuthModal} from '../type';

interface IProps {
  authModal: IAuthModal;
  isExistAlert: boolean;
  onClickLoginKakaoSdk: () => void;
  onClickLoginKakaoDirect: () => void;
  onClickClose: (isDimmedClicked?: boolean) => void;
  onClickIntegration: () => void;
}

export default function AuthModalKr({
  authModal,
  isExistAlert,
  onClickLoginKakaoSdk,
  onClickLoginKakaoDirect,
  onClickClose,
  onClickIntegration,
}: IProps) {
  const {t} = useTranslation();
  const {show, titleType} = authModal;
  const loginTitleKey = titleType && LOGIN_KR_TITLE_KEY_MAP[titleType];
  const title =
    loginTitleKey !== undefined ? t(loginTitleKey) : t('login_popup');
  const desc = (
    <KakaoAuth
      onClickLogin={onClickLoginKakaoSdk}
      onClickLoginDirect={onClickLoginKakaoDirect}
      onClickIntegration={onClickIntegration}
      showDaumAuthLink={true}
      isEmptyTitle={titleType === 'loginButton'}
    />
  );
  return (
    <Alert
      isOpen={show && !isExistAlert}
      title={title}
      desc={desc}
      onRequestClose={onClickClose}
      buttonSet={ButtonSet.Cancel}
      labelClose={t('common_close')}
      spaceClassName="px-20"
    />
  );
}
